import React from 'react'
import {messageStyle} from './constants'
import {TwMessage} from './containers'

interface Props {
  emojiOnly?: boolean
  onClick?: (e: React.MouseEvent) => void
  className?: string
}

export const Message = React.forwardRef(
  ({emojiOnly, onClick, className}: Props, ref) => (
    <TwMessage
      ref={ref}
      $larger={emojiOnly}
      onClick={onClick}
      style={messageStyle}
      className={className}
    />
  )
)
